import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import Slider from 'react-slick';

const TestimonialsSection = ({ 
  testimonial_section, 
  firmOnboarded, 
  testimonialSliderSettings,
  handleVideoClick 
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        background: 'linear-gradient(135deg, #E9F0F6, #F3EBDD)',
        border: '1px solid rgba(255,255,255,0.6)',
        boxShadow: '0px 6px 16px rgba(0,0,0,0.05)',
        py: 2,
        pl: 2,
        borderRadius: 2,
      }}
    > 
      <Typography variant="h2">
        {testimonial_section.header_title}
      </Typography>
      <Box sx={{
        overflow: 'hidden',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 1,
          maxWidth: { 
            xs: '430px', 
            md: '500px', 
            lg: '680px', 
            xl: '700px', 
          },
          width: 'fit-content',
          overflowX: 'scroll', 
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}>
          <Box sx={{ width: '100%' }}>
            <Slider {...testimonialSliderSettings}>
              {testimonial_section.videos.map((video, index) => (
                <Box key={index}>
                  <Box
                    sx={{
                      borderRadius: 2,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      position: 'relative',
                      width: { xs:'100px', md: '160px' },
                      height: { xs:'160px', md: 'auto' },
                    }}
                    onClick={() => handleVideoClick(index)}
                  >
                    <Box
                      component="video"
                      src={video?.link}
                      poster={video?.thumbnail}
                      autoPlay={false}
                      muted
                      loop
                      preload="metadata"
                      playsInline
                      webkit-playsinline="true"
                      crossOrigin="anonymous"
                      sx={{
                        width: { xs:'100px', md: '160px' },
                        // height: { xs:'177px', md: 'auto' },
                        objectFit: 'contain',
                        display: 'block',
                        borderRadius: 2,
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialsSection;